angular.module('rjmNg.services').factory('dataSampleService', [
  "$http"
  "$url"
  "app"
  "$q"
  ($http, $url, app, $q) ->

    cache = {}
    delim = String.fromCharCode 31

    dataSampleService = {}

    dataSampleService.sampleColumns = (tableId, columnIds, canceller, limit=100, force=false) ->
      if _(columnIds).isNumber()
        columnIds = [columnIds]

      if not _(columnIds).isArray()
        throw new Error("dataSampleService accepts a column id or an array of column ids. You gave: #{columnIds}")

      deferred = $q.defer()
      canceller ?= $q.defer()

      columns = JSON.stringify columnIds
      cacheId = "#{tableId}#{delim}#{columns}#{delim}#{limit}"

      if cache[cacheId]? and not force
        deferred.resolve cache[cacheId]
      else
        promise = $http
          method: 'POST'
          url: $url("/client/#{app.getClientId()}/table/#{tableId}/sample")
          data:
            columns: columnIds
            limit: limit
            force: force
          timeout: canceller.promise
        .then ({data}) ->
          unless data?
            return data
          cache[cacheId] = data

        promise.then ->
          deferred.resolve cache[cacheId]
        , (errorResponse) ->
          deferred.reject errorResponse

      return deferred.promise

    dataSampleService.multiTableSample = (columnsToSample, canceller, force=false) ->
      deferred = $q.defer()
      columnsByTable = {}
      for column in columnsToSample
        tableId = column.table_id
        if not columnsByTable[tableId]
          columnsByTable[tableId] = []
        columnsByTable[tableId].push column

      sampledData = []
      promises = []

      fetchSample = (tableId, columns) ->
        p = dataSampleService.sampleColumns(tableId, (c.id for c in columns), canceller, 100, force)
        .then (response) ->
          sampledData.push
            table: {id: tableId}
            columns: columns
            data: response.body
        promises.push p

      for tableId, columns of columnsByTable
        fetchSample parseInt(tableId), columns

      $q.all(promises)
      .then ->
        deferred.resolve sampledData
      .catch ({data}) ->
        deferred.reject data
      return deferred.promise

    return dataSampleService

  ]
)
